import { AccountMembershipRole, Invite, InvitePage } from '@mkp/account-membership/models';
import { createActionGroup, props } from '@ngrx/store';

export const editInviteActions = createActionGroup({
  source: 'Edit Invite',
  events: {
    'Delete Invite': props<{ inviteId: string; page: InvitePage }>(),
    'Update Invite': props<{ invite: Invite; roles: { role: AccountMembershipRole }[] }>(),
    'Resend Invite': props<{ invite: Invite; page: InvitePage }>(),
  },
});
